/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_List_Title1Inputs */

const vi_driverremittance_list_title1 = /** @type {(inputs: Driverremittance_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách phiếu nộp quỹ`)
};

/**

* @param {Driverremittance_List_Title1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_list_title1 = /** @type {((inputs?: Driverremittance_List_Title1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_List_Title1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_list_title1(inputs)
});
export { driverremittance_list_title1 as "driverRemittance_list_title" }